
import React, { useMemo, useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import apiUrl from "../../environment/Api";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import ActionsDropdown from "../ActionsDropdown";
import excelFile from "../../assets/course_demo.xlsx"; // Update this path to match your file location
import Select from "react-select";
import styled from "styled-components";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  useSortBy,
  usePagination,
} from "react-table";
import { createPortal } from "react-dom";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

const TableContainer = styled.div`
  padding: 20px;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;

  // Apply striped rows styling
  tr:nth-child(even) {
    background-color: #ffffff; /* Light gray for even rows */
  }

  tr:nth-child(odd) {
    background-color: #f2f2f2; /* White for odd rows */
  }
`;

const Th = styled.th`
  padding: 10px;
  background-color: #ffffff;
  text-align: left;
  cursor: pointer;
  position: relative;
`;

const Td = styled.td`
  padding: 10px;
  // border: 1px solid #f2f2f2;
`;

function GlobalFilter({ globalFilter, setGlobalFilter }) {
  return (
    <div style={{ marginBottom: "10px" }}>
      <input
        value={globalFilter || ""}
        onChange={(e) => setGlobalFilter(e.target.value)}
        placeholder="Search all columns..."
        style={{
          padding: "5px",
          border: "1px solid #ddd",
          borderRadius: "4px",
          width: "100%",
        }}
      />
    </div>
  );
}
// Default Column Filter (Icon-based)
const DefaultColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}) => {
  const [isActive, setIsActive] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const options = useMemo(() => {
    const uniqueValues = Array.from(
      new Set(preFilteredRows.map((row) => row.values[id]))
    ).map((value) => ({ label: value, value }));
    return [{ label: "All", value: "" }, ...uniqueValues];
  }, [id, preFilteredRows]);

  // Handle icon click
  const handleIconClick = () => {
    setIsActive(!isActive);
  };

  const handleMultiSelectChange = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFilter(values.length > 0 ? values : undefined);
  };

  return (
    <div style={{ alignItems: "center" }}>
      <div>
        <i
          className="fa-solid fa-ellipsis-vertical"
          onClick={handleIconClick}
          style={{
            cursor: "pointer",
            fontSize: "20px",
            color: "#AC0000",
          }}
        ></i>
      </div>
      <div>
        {isActive &&
          createPortal(
            <div
              style={{
                position: "fixed",
                zIndex: 9999,
                left: "50%",
                top: "50%",
                width: "30%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <div
                style={{
                  position: "relative",
                  background: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  backgroundColor: "#A70000",
                }}
              >
                <Select
                  options={options}
                  isMulti
                  value={options.filter((option) =>
                    filterValue?.includes(option.value)
                  )}
                  onChange={handleMultiSelectChange}
                  isClearable
                  isSearchable
                  placeholder={`Filter ${id}`}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                    }),
                  }}
                />
                <button
                  style={{
                    marginTop: "10px",
                    marginLeft: "150px",
                    padding: "5px 10px",
                    background: "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsActive(false)} // Close the popup
                >
                  Close
                </button>
              </div>
            </div>,
            document.body
          )}
      </div>
    </div>
  );
};

function Enquiry() {
  const [responseData, setResponseData] = useState([]);
  const [responseDatas, setResponseDatas] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isUpdateshowModal, setUpdateShowModal] = useState(false);
  const [Updateshow, setUpdateShow] = useState(false);
  const [deleteShowModals, setDeleteShowModals] = useState(false);
  const [role_id, setroleid] = useState("");
  const [previllages, setprevillages] = useState({});
  const navigate = useNavigate();
  const [selected_category, setselected_category] = useState("");
  const [category, setcategory] = useState([]);
  const [loading, setLoading] = useState(false);

  const data = useMemo(() => {
    return responseData.map((item) => ({
      _id: item._id,
      branch_id: item.branch_id?.branch_name,
      student_name: item.student_name,
      Prefered_course: item.Prefered_course,
      Source_type: item.Source_type,
      Enquiry_date: item.Enquiry_date,
      followups_status: item.followups_status,
      referal_candidate: item.referal_candidate,
      referal_candidate_name: item.referal_candidate_name,
      Enquiry_time: item.Enquiry_time,
    }));
  }, [responseData]);

  const columns = useMemo(
    () => [
      {
        Header: "S.No",
        id: "serialNo",
        Cell: ({ row }) => {
          return row.index + 1;
        },
      },
      {
        Header: "Branch",
        accessor: "branch_id",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Name",
        accessor: "student_name",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Course",
        accessor: "Prefered_course",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Source",
        accessor: "Source_type",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Date",
        accessor: (row) => {
          const date = new Date(row.Enquiry_date);
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
          const year = date.getFullYear();
          return `${day}-${month}-${year}`;
        },
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Status",
        accessor: "followups_status",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        width: 120,
        height: 10,
        Cell: ({ value }) => {
          const statusClass = getStatusLabelClass(value); // Get the class for the status

          return (
            <span
              className={`${statusClass}`} // Apply the class dynamically based on the status
              style={{
                display: "inline-block",
                width: "120px", // Set fixed width for the content
                height: "20px", // Set fixed height for the content
                lineHeight: "15px", // Vertically center text inside the span
                textAlign: "center", // Center align text horizontally
              }}
            >
              {value}
            </span>
          );
        },
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
    setPageSize,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 10 },
      defaultColumn: { Filter: DefaultColumnFilter },
      filterTypes: {
        multiSelectFilter: (rows, columnIds, filterValue) => {
          if (!filterValue || filterValue.length === 0) {
            return rows;
          }
          return rows.filter((row) => {
            const rowValue = row.values[columnIds[0]];
            const rowValueStr = String(rowValue);
            return filterValue.some((filterVal) =>
              rowValueStr.includes(String(filterVal))
            );
          });
        },
      },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const updateinfo = (_id) => {
    navigate(`/Leadhistroy/${_id}`);
  };

  const handleUpdatednew = (_id, data) => {
    setUpdateId(_id);
    console.log(" the data to updata", data);
    setUpdateShow(true);
    setUpdateData({
      branch_id: UpdatedData.branch_id,
      student_name: UpdatedData.student_name,
      mobile_no: UpdatedData.mobile_no,
      email: UpdatedData.email,
      other_location: UpdatedData.other_location,
      Source_type: UpdatedData.Source_type,
      referal_candidate: UpdatedData.referal_candidate,
      referal_candidate_name: UpdatedData.referal_candidate_name,
      Enquiry_date: UpdatedData.Enquiry_date,
      Enquiry_time: UpdatedData.Enquiry_time,
      Perfered_course: UpdatedData.selectcourse,
    });
  };

  const [UpdatedData, setUpdatedData] = useState([]);

  const handleUpdated = async (_id, data) => {
    if (previllages.edit || previllages.all) {
      try {
        console.log("this", _id, data);

        // Fetch the updated data from the API
        const filterUpdateData = await axios.get(apiUrl + `/leads/${_id}`);
        console.log("filterUpdateData___999", filterUpdateData.data?.[0]);
        const filterUpdateDatas = filterUpdateData.data?.[0];

        console.log(
          "filterUpdateData___999",
          filterUpdateDatas.Prefered_course
        );
        console.log(
          "filterUpdateData___99922",
          filterUpdateDatas.Prefered_course
        );

        // Set the updated data to the state
        setUpdatedData(filterUpdateDatas);
        console.log("filterUpdateData___999", UpdatedData.Prefered_course);

        const courses = responseDatas.find(
          (item) => item.course_name === filterUpdateDatas.Prefered_course
        );

        if (courses) {
          const coursedata = courses.category_list;
          console.log("the course", courses);
          console.log("the course category_list", coursedata);

          // Set category data to state
          setUpdatedData((prevData) => ({
            ...prevData,
            category: coursedata,
          }));
        } else {
          console.log("No matching course found for Prefered_course.");
        }

        console.log("filterUpdateData___category ", UpdatedData.category);
        // Show the update modal or component
        setUpdateShow(true);
      } catch (error) {
        console.error("Error fetching updated data:", error);
      }
    } else {
      console.log(
        "You do not have the necessary privileges to edit this data."
      );

      toast.error("You don't have the permission to update");
    }
  };

  const formatDatefitching = (isoDate) => {
    if (!isoDate) return ""; // Return an empty string if no date is provided
    const date = new Date(isoDate);
    return date.toISOString().split("T")[0]; // Format as YYYY-MM-DD
  };

  const formatDateTime = () => {
    const currentTime = new Date(); // Get the current date and time
    const lastTime = new Date(currentTime); // Create a copy of currentTime to modify it

    // Subtract 1 second from the lastTime
    lastTime.setSeconds(lastTime.getSeconds() - 1);

    const hours = lastTime.getHours().toString().padStart(2, "0"); // Get hours (with leading zero)
    const minutes = lastTime.getMinutes().toString().padStart(2, "0"); // Get minutes (with leading zero)
    const seconds = lastTime.getSeconds().toString().padStart(2, "0"); // Get seconds (with leading zero)

    return `${hours}:${minutes}:${seconds}`; // Return formatted date and time
  };

  // current date//////////////////////////////

  useEffect(() => {
    // Get current time in HH:MM format
    const currentTime = new Date().toLocaleTimeString("en-US", {
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
    });

    console.log("the time current", currentTime);
    setUpdatedData((prevData) => ({
      ...prevData,
      followups_time: currentTime,
    }));
    formatDateTime();
  }, []);

  const formatDate = (isoDate) => {
    if (!isoDate) return ""; // Return an empty string if no date is provided
    const date = new Date(isoDate);

    const day = date.getDate().toString().padStart(2, "0"); // Add leading zero for single-digit days
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Add leading zero for single-digit months
    const year = date.getFullYear();

    return `${day}-${month}-${year}`; // Format as "day-month-year"
  };

  const [addData, setAddData] = useState({
    branch_id: "",
    selectcourse: "",
    student_name: "",
    father_name: "",
    timings: "",
    category: "",
    date: formatDatefitching(new Date()),
    Enquiry_time: formatDateTime(new Date()),
    other_location: "",
    dateofbirth: "",
    qualification: "",
    purpose_enquiry: "",
    mobile_no: "",
    email: "",
    notes: "",

    status: "",
    total_fees: "",
    paid: "",
    balance: "",
    student_type: "",
    Source_type: "",
    location: "",
    callback_date: "",
    converted_status: "",
    completed: "",
    referal_candidate: "",
    referal_candidate_name: "",
    course_id: "",
  });

  const getCurrentTime = () => {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  // Set the current time on component mount
  useEffect(() => {
    setUpdatedData((prev) => ({
      ...prev,
      followups_time: getCurrentTime(),
    }));
    console.log("the time current1212", UpdatedData.followups_time);
  }, []);

  const [updateData, setUpdateData] = useState({
    student_name: "",

    date: formatDate(new Date()),
    followups_time: getCurrentTime(),
    mobile_no: "",
    status: "",
    callback_date: "",
    other_location: "",
    roll_no: "",
    photo_upload: "",
    id_proof: "",
  });
  const [idlocal, setlocalid] = useState([]);
  useEffect(() => {
    fetchData();
    const id_local = localStorage.getItem("username");
    setlocalid(id_local);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [status, setStatus] = useState([]);

  const fetchData = async () => {
    try {
      // setLoading(true);

      const response = await axios.get(apiUrl + "/leads", {
        params: { data: localStorage.getItem("branch_id") },
      });
      console.log("the brnafdasfasdfasfdsadfd", response);

      const username = localStorage.getItem("username");
      const branch_name = localStorage.getItem("branch_name");
      console.log("the brnafdasfd", branch_name);
      console.log("the username", username);

      if (branch_name === "Branches") {
        if (response && response.data) {
          const data = response.data;
          const filteredData = data.filter(
            (item) => item.status !== "Converted"
          );
          console.log("Response from serverrrr:filteredDatas112", filteredData);
          setResponseData(filteredData);
        }
      } else {
        const username = localStorage.getItem("username");
        const internal_emp = localStorage.getItem("internal_emp");
        console.log(
          "Response from serverrrr:filteredDatas112response.data",
          response.data
        );
        const filteredDatas = response.data.filter(
          (item) =>
            item.assign_staff?.empid === username ||
            item.assign_staff?.empid === internal_emp
        );

        const statusCounts = {
          "Phone Ringing": 0,
          Unqualified: 0,
          NotReachable: 0,
          Converted: 0,
          New: 0,
          Rescheduled: 0,
          Scheduled: 0,
          Walkin: 0, // Added Walkin in case you want to handle it
        };

        // Iterate over filtered data and increment the corresponding status count
        filteredDatas.forEach((item) => {
          if (statusCounts[item.followups_status] !== undefined) {
            statusCounts[item.followups_status]++;
          }
        });

        // Create an array of objects with count and followups_status
        const statusArray = Object.keys(statusCounts).map((key) => ({
          count: statusCounts[key],
          followups_status: key,
        }));

        // Update the state with the new status data
        setStatus((prevStatus) => [...prevStatus, ...statusArray]);

        // Optional: Log the final counts to the console for debugging
        console.log("Updated status data:", statusArray);

        set_categoriescount(statusArray);

        console.log("Response get all", status);

        console.log("Response from serverrrr:filteredDatas", filteredDatas);
        // console.log("Response from serverrrr:", response.data.reverse());
        setResponseData(filteredDatas);
      }

      setTimeout(() => {
        setLoading(false);
      }, 1000);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    gettoken();
    getprevillages();
  }, []);

  const gettoken = async () => {
    const token = localStorage.getItem("token");
    // console.log("the toekn in the localStorage is : ",token);
    try {
      const response = await axios.post(apiUrl + "/get_detail", {
        token: token,
      });
      console.log("token detail from server:", response.data);
      // setResponseData(response.data);

      console.log("The role id is : ", response.data.detail.rolename);
      setroleid(response.data.detail.rolename);
      console.log("the role_id is : ", role_id);

      localStorage.setItem("role_id", response.data.detail.rolename);

      const id = response.data.detail.rolename;

      // getpages();

      if (id) {
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const username = localStorage.getItem("username");

  const getprevillages = () => {
    const username = JSON.parse(localStorage.getItem("user_previllages"));
    console.log("tyhe username get by local stroage : ", username.modules);

    const total_previlages = username.modules;

    const new_enquiry = total_previlages.find((item) => item.name == "Enquiry");

    console.log("the new_enquiry is : ", new_enquiry.actions);

    setprevillages(new_enquiry.actions);
  };

  const handlesubmit = async (e) => {
    console.log("this is ");
    e.preventDefault();
    if (!validateFields()) {
      return;
    }
    try {
      setLoading(true);
      const formData = {
        branch_id: addData.branch_id,
        student_name: addData.student_name,
        mobile_no: addData.mobile_no,
        category: addData.category,
        email: addData.email,
        other_location: addData.other_location,
        Source_type: addData.Source_type,
        referal_candidate: addData.referal_candidate,
        referal_candidate_name: addData.referal_candidate_name,
        Enquiry_date: addData.date,
        Enquiry_time: formatDateTime(addData.Enquiry_time),
        Prefered_course: addData.selectcourse,
        followups_status: "New",
        course_id: addData.course_id,
        qualification: addData.qualification,
        purpose_enquiry: addData.purpose_enquiry,
      };

      console.log("formData,OO:", formData);
      const response = await axios.post(apiUrl + "/leads", formData);

      console.log("the histroy beginds", response);

      setShowModal(false);

      toast.success("added successfully!");
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      setAddData({
        branch_id: "",
        student_name: "",
        mobile_no: "",
        email: "",
        other_location: "",
        category: "",
        Source_type: "",
        referal_candidate: "",
        referal_candidate_name: "",
        date: formatDatefitching(new Date()),
        followups_status: "",
        student_type: "",
        // Enquiry_time:"",
        selectcourse: "",
        qualification: "",
        purpose_enquiry: "",
      });
      fetchData();
    } catch (error) {
      console.log("the error executed");
      console.error("Error updating data:", error.message);
    }
  };

  const [updateid, setUpdateId] = useState("");

  // ////////////////////////
  const [firstTime, setFirstTime] = useState(null);
  const [lasttimess, setLastTime] = useState(null);
  const [timeDifference, setTimeDifference] = useState("");

  const updateshow = async (_id, data) => {
    const currentTimes = new Date().toLocaleTimeString();

    console.log(`Current Time: ${currentTimes}`);
    setFirstTime(currentTimes);

    setUpdateId(data._id);
    console.log("this", _id);
    // setUpdatedData(data);
    // console.log("this is updateData",updateData)
    const filterUpdateData = await axios.get(apiUrl + `/leads/${_id}`);

    // const filterUpdateData= responseData.filter((iteam,index)=>iteam._id === _id)

    console.log(
      "the filter daata is find here",
      filterUpdateData.data?.[0],
      "filterUpdateData___999"
    );
    setUpdatedData(filterUpdateData.data?.[0]);
    console.log(" the data to updata", data);
    console.log("data.assign_staff:1212", data.Prefered_course);
    console.log("localStorage.assignId:", localStorage.getItem("assignId"));

    const courses = responseDatas.find(
      (item) => item.course_name === data.Prefered_course
    );
    console.log("the courserr12", courses);
    if (courses) {
      const coursedata = courses.category_list;
      console.log("the courserr12", courses);
      console.log("the course category_list", coursedata);

      // Set category data to state
      setUpdatedData((prevData) => ({
        ...prevData,
        category: coursedata,
      }));
    } else {
      console.log("No matching course found for Prefered_course.");
    }

    console.log("filterUpdateData___category ", UpdatedData.category);

    setUpdateShowModal(true);
    setUpdateData({
      branch_id: data.branch_id,
      student_name: data.student_name,
      mobile_no: data.mobile_no,
      email: data.email,
      category: data.category,
      Source_type: data.Source_type,
      other_location: data.other_location,
      referal_candidate: data.referal_candidate,
      referal_candidate_name: data.referal_candidate_name,
      followups_date: data.date,
      followups_status: data.followups_status,
      followups_time: data.followups_time,
      assign_staff: data.assign_staff,
      Enquiry_date: data.date,
      Enquiry_time: data.Enquiry_time,
      Prefered_course: data.Prefered_course,
      // followups_status: "new",
      followups_status: data.followups_status,
      qualification: data.qualification,
      purpose_enquiry: data.purpose_enquiry,
      course_id: "",
    });
  };
  console.log("this is updateDataPrefered_course", updateData.Prefered_course);

  const handleupdatesubmit = async (id) => {
    try {
      console.log(id, "idddss");
      const updateDatas = {
        branch_id: UpdatedData.branch_id,
        student_name: UpdatedData.student_name,
        mobile_no: UpdatedData.mobile_no,
        email: UpdatedData.email,
        other_location: UpdatedData.other_location,
        category: UpdatedData.category,
        Source_type: UpdatedData.Source_type,
        referal_candidate: UpdatedData.referal_candidate || "",
        referal_candidate_name: UpdatedData.referal_candidate_name || "",
        assign_staff:
          UpdatedData.assign_staff || localStorage.getItem("assignId"),
        followups_date: UpdatedData.followups_date,
        followups_status: UpdatedData.followups_status,
        Enquiry_date: UpdatedData.Enquiry_date,
        Enquiry_time: UpdatedData.Enquiry_time,
        Prefered_course: UpdatedData.Prefered_course,
        course_id: UpdatedData.course_id,
        qualification: UpdatedData.qualification,
        purpose_enquiry: UpdatedData.purpose_enquiry,
      };

      try {
        setLoading(true);
        console.log("The console update  data as is : ", updateDatas, updateid);
        const response = await axios.put(apiUrl + `/leads/${id}`, updateDatas);
        console.log("the response : ", response);

        if (response.status == 200) {
          fetchData();
          toast.success("updated sucessfully!");
          setUpdateShow(false);
        } else {
          toast.error("failed to convert !");
        }
      } catch (error) {
        toast.error("error in convert !");
        console.log("Error fetching data:", error.message);
      }
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };
  const [detailsData, setDetailsData] = useState({
    assign_staff: "",
    contact_type: "",
    followups_date: "",
    followups_status: "",
    followups_time: "",
  });

  const handleupdatesubmitdetails = async (id) => {
    try {
      const lasttimess = new Date().toLocaleTimeString("en-US", {
        hour12: true,
      });
      console.log(`End Time: ${lasttimess}`);
      setLastTime(lasttimess);
      console.log(`Start Time: ${firstTime}`);

      // Convert to Date object for calculation
      const firstTimeDate = new Date(
        `1970-01-01T${convertTo24Hour(firstTime)}Z`
      );
      const lastTimeDate = new Date(
        `1970-01-01T${convertTo24Hour(lasttimess)}Z`
      );

      // Calculate the time difference in seconds
      const timeDifferenceInMillis = lastTimeDate - firstTimeDate;
      const timeDifferenceInSeconds = Math.max(
        timeDifferenceInMillis / 1000,
        0
      );

      // Convert time difference into hh:mm:ss format
      const formatDuration = (seconds) => {
        const hrs = Math.floor(seconds / 3600)
          .toString()
          .padStart(2, "0");
        const mins = Math.floor((seconds % 3600) / 60)
          .toString()
          .padStart(2, "0");
        const secs = (seconds % 60).toString().padStart(2, "0");
        return `${hrs}:${mins}:${secs}`;
      };

      const durationFormatted = formatDuration(timeDifferenceInSeconds);
      console.log(`Time difference: ${durationFormatted}`);

      setTimeDifference(durationFormatted);

      function convertTo24Hour(time) {
        const [timePart, modifier] = time.split(" ");
        let [hours, minutes, seconds] = timePart.split(":");

        if (modifier === "PM" && hours !== "12") hours = parseInt(hours) + 12;
        if (modifier === "AM" && hours === "12") hours = "00";

        return `${hours}:${minutes}:${seconds}`;
      }

      console.log(id, "the enquiry update schedule");

      const updateDatasDetails = {
        branch_id: UpdatedData.branch_id,
        student_name: UpdatedData.student_name,
        mobile_no: UpdatedData.mobile_no,
        email: UpdatedData.email,
        other_location: UpdatedData.other_location,
        category: UpdatedData.category,
        Source_type: UpdatedData.Source_type,
        referal_candidate: UpdatedData.referal_candidate || "",
        referal_candidate_name: UpdatedData.referal_candidate_name || "",
        Enquiry_date: UpdatedData.Enquiry_date,
        Prefered_course: UpdatedData.Prefered_course,
        assign_staff:
          UpdatedData.assign_staff || localStorage.getItem("assignId"),
        contact_type: UpdatedData.contact_type,
        interest: UpdatedData.interest,
        followups_date: UpdatedData.followups_date,
        followups_time: UpdatedData.followups_time,
        qualification: UpdatedData.qualification,
        purpose_enquiry: UpdatedData.purpose_enquiry,
        followups_status:
          UpdatedData.followups_status === "New"
            ? "Scheduled"
            : UpdatedData.followups_status,
        duration_time: durationFormatted, // Updated here
        start_time: firstTime,
        end_time: lasttimess,
        Enquiry_time: UpdatedData.Enquiry_time,
      };

      try {
        console.log(
          "The console update data as is: ",
          updateDatasDetails,
          updateid
        );
        const response = await axios.put(
          apiUrl + `/leads/${id}`,
          updateDatasDetails
        );
        console.log("The response: ", response);

        const student_Id = response.data._id;
        console.log("The history update post", student_Id);

        const formDataaa = {
          student_Id: student_Id,
          Source_type: "",
          Enquiry_date: "",
          contact_type: UpdatedData.contact_type,
          assign_staff: UpdatedData.assign_staff,
          notes: "Scheduled",
          status: UpdatedData.followups_status,
          duration_time: durationFormatted, // Updated here
          start_time: firstTime,
          end_time: lasttimess,
          followups_time: UpdatedData.followups_time,
          Enquiry_time: UpdatedData.Enquiry_time,
          followups_status: UpdatedData.followups_status,
        };

        if (response.status === 200) {
          const response12 = await axios.post(
            apiUrl + "/leadhistroy",
            formDataaa
          );
          console.log("The history begins", response12);
        }

        if (response.status === 200) {
          fetchData();
          toast.success("Updated successfully!");
          setUpdateShowModal(false);
        } else {
          toast.error("Failed to update!");
        }
      } catch (error) {
        toast.error("Error in update!");
        console.log("Error fetching data:", error.message);
      }
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  useEffect(() => {
    fetchDatased();
    fetch();
    fetchDat();
  }, []);

  const [branch, setbranch] = useState([]);
  const [studentId, setSutudentId] = useState([]);
  const [stafftId, setStaffId] = useState([]);
  const [purpose, setpurpose] = useState([]);
  const [source, setsource] = useState([]);

  const fetchDatased = async () => {
    try {
      const response = await axios.get(apiUrl + "/Branch");
      const responsestudent = await axios.get(apiUrl + "/student");
      const responsestaff = await axios.get(apiUrl + "/staff");
      const responsepurposes = await axios.get(apiUrl + "/enquiry_purpose");
      const responsesourses = await axios.get(apiUrl + "/source_type");
      console.log("Response from server:", response.data);
      setsource(responsesourses.data);
      setpurpose(responsepurposes.data);
      setbranch(response.data);
      setSutudentId(responsestudent.data);
      setStaffId(responsestaff.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };
  const [referaltype, setreferaltype] = useState("");

  const handlereferal = (e) => {
    console.log(e.target.value);
    setAddData({ ...addData, referal_candidate: e.target.value });
    setreferaltype(e.target.value);
  };
  const [seduledStatus, setSeduledStatus] = useState("");

  function handleschuduleStatus(e) {
    console.log(e.target.value);
    setAddData({ ...addData, referal_candidate_name: e.target.value });
    setSeduledStatus(e.target.value);
  }
  const handleDelete = async (id) => {
    try {
      setLoading(true);
      const response = await axios.delete(apiUrl + `/leads/${getdeleteid}`);
      console.log("delete data ", response);
      toast.error("Delete successfully!");
      setDeleteShowModals(false);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };
  const handleCloseModal = () => {
    setDeleteShowModals(false);
  };

  const [getdeleteid, setdeleteid] = useState("");
  const [getdeletename, setdeletename] = useState("");
  const handleOpenModal = (_id, student_name) => {
    if (previllages.all || previllages.delete) {
      console.log(" the id", _id);
      console.log(" the studentname", student_name);
      setdeleteid(_id);
      setdeletename(student_name);
      setDeleteShowModals(true);
    } else {
      toast.error("You don't have the permission");
    }
  };

  const createPagination = () => {
    let liTag = [];
    let totalPages = pageCount; // Total pages
    let currentPage = state.pageIndex;
    let active;

    // Previous Page Button
    liTag.push(
      <li
        className={`page-item ${!canPreviousPage ? "disabled" : ""}`}
        key="prev"
      >
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage - 1)}
          disabled={!canPreviousPage}
        >
          <FaAngleLeft /> Prev
        </button>
      </li>
    );

    // Always show first page
    if (totalPages > 1) {
      liTag.push(
        <li
          className={`page-item ${currentPage === 0 ? "active" : ""}`}
          key={0}
        >
          <button className="page-link" onClick={() => gotoPage(0)}>
            1
          </button>
        </li>
      );
    }

    // Show second page if total pages > 2
    if (totalPages > 2) {
      liTag.push(
        <li
          className={`page-item ${currentPage === 1 ? "active" : ""}`}
          key={1}
        >
          <button className="page-link" onClick={() => gotoPage(1)}>
            2
          </button>
        </li>
      );
    }

    // Add "..." before current page group
    if (currentPage > 3) {
      liTag.push(
        <li className="page-item disabled" key="dot-prev">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Show 3 pages around current page
    for (
      let i = Math.max(2, currentPage - 1);
      i <= Math.min(totalPages - 3, currentPage + 1);
      i++
    ) {
      active = currentPage === i ? "active" : "";
      liTag.push(
        <li className={`page-item ${active}`} key={i}>
          <button className="page-link" onClick={() => gotoPage(i)}>
            {i + 1}
          </button>
        </li>
      );
    }

    // Add "..." after current page group
    if (currentPage < totalPages - 4) {
      liTag.push(
        <li className="page-item disabled" key="dot-next">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Always show last two pages if totalPages > 2
    if (totalPages > 2) {
      liTag.push(
        <li
          className={`page-item ${currentPage === totalPages - 2 ? "active" : ""
            }`}
          key={totalPages - 2}
        >
          <button
            className="page-link"
            onClick={() => gotoPage(totalPages - 2)}
          >
            {totalPages - 1}
          </button>
        </li>
      );
    }

    if (totalPages > 1) {
      liTag.push(
        <li
          className={`page-item ${currentPage === totalPages - 1 ? "active" : ""
            }`}
          key={totalPages - 1}
        >
          <button
            className="page-link"
            onClick={() => gotoPage(totalPages - 1)}
          >
            {totalPages}
          </button>
        </li>
      );
    }

    // Next Page Button
    liTag.push(
      <li className={`page-item ${!canNextPage ? "disabled" : ""}`} key="next">
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage + 1)}
          disabled={!canNextPage}
        >
          Next <FaAngleRight />
        </button>
      </li>
    );

    return liTag;
  };

  function handleChangeSatus(e) {
    const course = responseDatas.filter(
      (item, index) => item.course_id == e.target.value
    );
    console.log(course, "course---");
    setAddData({
      ...addData,
      course_id: e.target.value,
      selectcourse: course[0]?.course_name || "Course Not Found", // Fallback if no course is found
    });
  }

  function interstedHandel(e) {
    console.log(e.target.value);

    setUpdatedData((prevData) => ({
      ...prevData,
      interest: e.target.value,
    }));
  }

  const getStatusLabelClass = (status) => {
    switch (status) {
      case "Unqualified":
        return "bg-danger1 text-white1 ";
      case "Converted":
        return "bg-success1 text-white1 ";
      case "Rescheduled":
        return "bg-primary1 text-white1 ";
      case "Walkin":
        return "bg-warning1 text-white1 ";
      case "NotReachable":
        return "bg-dark1 text-white1";
      case "New":
        return "bg-info1 text-white1";
      case "Walk-in-reschedule":
        return "bg-dark1 text-white1";
      case "Scheduled":
        return "bg-secondary1 text-white1 ";
      case "Phone Ringing":
        return "bg-phone text-white1 ";
      default:
        return "";
    }
  };

  const fetchDat = async (selected_category_2) => {
    try {
      const response = await axios.get(apiUrl + "/course");
      console.log("Response from server:123", response.data);
      console.log("Response from category list :", category);
      console.log("the selected_category is : ", selected_category_2);

      setResponseDatas(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const fetchDatas_2 = async (selected_category_2) => {
    try {
      const response = await axios.get(
        apiUrl + "/category_course/" + selected_category_2
      );
      console.log("Response from server:", response.data);
      if (response && response.data) {
        const data = response.data;

        setResponseDatas(data);
      } else {
        console.error("No data received from server.");
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const handleAdditionalChange = async (e) => {
    const selectcategory = e.target.value; // Get the selected value from the dropdown

    setselected_category(e.target.value);

    fetchDatas_2(e.target.value);
    console.log(
      "Additional change function called with value:",
      selectcategory
    );
  };

  const fetch = async () => {
    try {
      const response = await axios.get(apiUrl + "/category_list");
      console.log("Response from server:", response.data);
      console.log("Response from category list :", category);
      setcategory(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const handleSelectChange = (e) => {
    setUpdatedData({
      ...UpdatedData,
      purpose_enquiry: e.target.value, // Update state with the selected option
    });
  };

  const handleSelectChangesource = (e) => {
    setUpdatedData({
      ...UpdatedData,
      Source_type: e.target.value, // Update state with the selected option
    });
  };

  const [errors, setErrors] = useState({});

  const validateFields = () => {
    let tempErrors = {};
    let isValid = true;

    if (!addData.branch_id) {
      tempErrors.branch_id = "branch Name is required.";
      isValid = false;
    }

    if (!addData.student_name) {
      tempErrors.student_name = "Name is required.";
      isValid = false;
    }

    if (!addData.purpose_enquiry) {
      tempErrors.purpose_enquiry = " purpose Enquiry is required.";
      isValid = false;
    }

    if (!addData.mobile_no) {
      tempErrors.mobile_no = "Mobile is required.";
      isValid = false;
    }

    if (!/^\d{10}$/.test(addData.mobile_no)) {
      tempErrors.mobile_no = "Mobile number must be 10 digits.";
      isValid = false;
    }

    if (!addData.email) {
      tempErrors.email = "Email is required.";
      isValid = false;
    }
    if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(addData.email)
    ) {
      tempErrors.email = "Please enter a valid email address.";
      isValid = false;
    }

    if (!addData.category) {
      tempErrors.category = "Category is required.";
      isValid = false;
    }
    if (!addData.course_id) {
      tempErrors.course_id = "Course is required.";
      isValid = false;
    }

    if (!addData.qualification) {
      tempErrors.qualification = "Qualification is required.";
      isValid = false;
    }

    if (!addData.Source_type) {
      tempErrors.Source_type = "Source Type is required.";
      isValid = false;
    }
    setErrors(tempErrors);
    return isValid;
  };

  const [selectedCourse, setSelectedCourse] = useState(
    UpdatedData.Prefered_course || ""
  );

  // Handle the change event
  const handleCourseChange = (event) => {
    setSelectedCourse(event.target.value);
    setUpdatedData({ ...UpdatedData, Prefered_course: event.target.value });
  };

  const [rolename, setrolename] = useState([]);
  useEffect(() => {
    const branchName = localStorage.getItem("branch_name");
    setrolename(branchName);
  }, []);

  // ============== code to show the categori count =========================
  const [categoriescount, set_categoriescount] = useState([]);

  useEffect(() => {
    const branchId = localStorage.getItem("branch_id");
    if (branchId == "null") {
      console.log("The local storage branch_id is null : ");

      const fetch_overall_data = async () => {
        try {
          const response = await axios.get(apiUrl + "/leads_count_overall");
          console.log(
            "Response from server with status-count-overall data:",
            response.data
          );

          // set_categoriescount(response.data);

          const receivedData = response.data;

          // Define required categories
          const requiredCategories = [
            "New",
            "Scheduled",
            "Rescheduled",
            "Walkin",
            "Converted",
            "NotReachable",
            "Unqualified",
            "Phone Ringing",
          ];

          // Ensure all categories are present
          const updatedData = requiredCategories.map((status) => {
            const existingCategory = receivedData.find(
              (item) => item.followups_status === status
            );
            return existingCategory || { count: 0, status }; // If not found, add with count 0
          });

          set_categoriescount(updatedData);

          console.log("The updatedData in the useeffect is : ", updatedData);
        } catch (error) {
          console.error("Error fetching data:", error.message);
        }
      };

      fetch_overall_data();
    } else {
      const username = localStorage.getItem("username");

      console.log("The local storage branch_id is null : ");

      const fetch_branch = async () => {
        try {
          const receivedData = [
            "New",
            "Scheduled",
            "Rescheduled",
            "Walkin",
            "Converted",
            "NotReachable",
            "Unqualified",
            "Phone Ringing",
          ];

          // Ensure all categories are present
          const updatedData = status.map((status) => {
            const existingCategory = receivedData.find(
              (item) => item.followups_status === status
            );
            return existingCategory || { count: 0, status }; // If not found, add with count 0
          });

          setStatus(updatedData);

          console.log("The updatedData in the useeffect is : ", updatedData);
        } catch (error) {
          console.error("Error fetching data:", error.message);
        }
      };

      fetch_branch();
    }

    console.log("The useeffect function is called ", branchId == "null");
  }, []);
  // ============== code to show the categori count =========================

  // ========== code to set the color for the label ===================
  const getStatusColor = (status) => {
    switch (status) {
      case "Walkin":
        return "#ffc107"; // Green
      case "Scheduled":
        return "#6c757d"; // Blue
      case "Rescheduled":
        return "#007bff"; // Yellow
      case "NotReachable":
        return "#343a40"; // Gray
      case "New":
        return "#17a2b8"; // Light Blue
      case "Unqualified":
        return "#dc3545"; // Red
      case "Converted":
        return "#28a745";
      case "Phone Ringing":
        return "#F0A04B"; // Black // Black
      default:
        return "bg-light"; // Default Light Gray
    }
  };
  // ========== code to set the color for the label ===================

  const handleSelectChangedd = (e) => {
    setUpdatedData({
      ...UpdatedData,
      assign_staff: e.target.value,
    });
  };

  function interstedHandel(e) {
    console.log(e.target.value);

    setUpdatedData((prevData) => ({
      ...prevData,
      interest: e.target.value,
    }));
  }
  return (
    <>
      {loading === true ? (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/output-onlinegiftools.gif")}
            />{" "}
          </div>
        </div>
      ) : (
        <div className="d-none"></div>
      )}

      <div className="top">
        <div className="" style={{ marginTop: "-80px" }}>
          <div className="row mb-3">
            <div className="col-lg-11">
              <Link to="/dashboard" className="text-secondary dashBoard_text">
                <b>Dashboard / </b>
              </Link>
              <Link to="#" className="text-secondary dashBoard_text">
                <b>Leads / </b>
              </Link>
              <Link to="" className="text-danger dashBoard_text">
                <b>Enquiry</b>
              </Link>
            </div>
          </div>
        </div>

        <div
          className="card p-2"
          style={{
            // marginTop: "-80px",
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
            marginBottom: "10px",
          }}
        >
          <div className="row">
            {categoriescount.map((item, index) => (
              <div key={index} className="col-lg-3 col-md-6 col-sm-12">
                <div
                  className="card text-center border-3"
                  style={{ marginBottom: "10px" }}
                >
                  {/* <h6 className="bg-secondary text-white py-1">{item.followups_status }</h6> */}
                  <h6
                    className="text-white py-1"
                    style={{
                      backgroundColor: getStatusColor(item.followups_status),
                      color: "white",
                    }}
                  >
                    {item.followups_status}
                  </h6>
                  <h3 className="">{item.count}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>



        {/* ------------ search and per page ----------------------------*/}

        <div className="mb-1 mt-3">
          <div className="row">
            <div className="col-lg-7 col-md-4 col-sm-1">
              <div className="row">
                <div className="col-lg-10 d-flex">
                  <h5 className="mt-2">Enquiry</h5>
                  <div className="mx-3"></div>
                </div>
                <div className="col-lg-2"></div>
              </div>
            </div>
            <div className="col-lg-5 col-md-4 col-sm-4 d-flex justify-content-between">
            {/* </div>
            <div className="col-lg-3 col-md-4 col-sm-7"> */}
              <div className="w-full flex-1 ms-5 ps-3">
                <form>
                  <div className="relative">
                    <input
                      className="form-control w-full bg-white appearance-none pl-8 dark:bg-gray-950"
                      placeholder="Search ..."
                      type="search"
                      value={state.globalFilter || ""} // Use the globalFilter value
                      onChange={(e) => setGlobalFilter(e.target.value)} // Update global filter
                    />
                  </div>
                </form>
              </div>
              <div className="d-flex me-2">
                <label className="form-label text-dark mt-1">Show : </label>
              <div>
                <select
                  className="form-control w-100 mx-2"
                  value={state.pageSize}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "All") {
                      setPageSize(data.length); // 'data' should be your dataset containing all the entries
                    } else {
                      setPageSize(Number(value));
                    }
                  }}
                >
                  <option value="All">All</option> {/* Add 'All' option */}
                  {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                      {pageSize}
                    </option>
                  ))}
                </select>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* --------------------------------end------------------------------------------- */}

      {/* Table */}
      <Table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  <div className="d-flex">
                    <div className="mx-2">{column.render("Header")}</div>
                    <div>
                      {column.canFilter ? column.render("Filter") : null}
                    </div>
                    <div className="mx-1">
                      {column.isSorted
                        ? column.isSortedDesc
                          ? " 🔽"
                          : " 🔼"
                        : ""}
                    </div>
                  </div>
                </Th>
              ))}
              <Th className="text-center">Action</Th>
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <Td {...cell.getCellProps()}>{cell.render("Cell")}</Td>
                ))}
                <Td className="text-center">
                  <ActionsDropdown
                    row={row.original}
                    permissions={{
                      edit: previllages.edit,
                      delete: previllages.delete,
                    }}
                    onEdit={(id, row) =>
                      handleUpdated(id, row)
                    }
                    onDelete={(id, row) =>
                      handleOpenModal(id, row.student_name)
                    }
                    onAssign={(id, row) =>
                      updateshow(id, row)
                    }
                    onInfo={(id) => {
                      setLoading(true);
                      setTimeout(() => {
                        updateinfo(id);
                        setLoading(false);
                      }, 1000);
                    }}
                  />
                </Td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      {console.log(UpdatedData, "UpdatedData is   form previous----")}

      <Modal show={Updateshow} onHide={() => setUpdateShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title id="modeti">Enquiry Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Other input fields */}
          <div className="row">
            <div className="col-lg-12 ">
              <div className=" p-2 pb-0">
                <div className="form-group">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="floating-label ">
                        <label className="form-label">
                          <b></b>
                        </label>
                        <select
                          className="form-select"
                          placeholder=""
                          value={UpdatedData.branch_id}
                          onChange={(e) =>
                            setUpdatedData({
                              ...UpdatedData,
                              branch_id: e.target.value,
                            })
                          }
                          required
                        >
                          <option value="">Select Branch </option>
                          {branch.map((item, index) => (
                            <option key={index} value={item._id}>
                              {item.branch_name}
                            </option>
                          ))}
                        </select>
                        <label
                          className={addData.branch_id ? "filled" : ""}
                        ></label>
                      </div>

                      <div className="floating-label">
                        <input
                          className="form-control"
                          type="text"
                          placeholder=""
                          value={UpdatedData.student_name}
                          onChange={(e) =>
                            setUpdatedData({
                              ...UpdatedData,
                              student_name: e.target.value,
                            })
                          }
                          required
                        />
                        <label className={addData.student_name ? "filled" : ""}>
                          Name
                        </label>
                      </div>

                      <div className="floating-label">
                        <input
                          className="form-control"
                          type="tel"
                          placeholder=""
                          value={UpdatedData.mobile_no}
                          onChange={(e) =>
                            setUpdatedData({
                              ...UpdatedData,
                              mobile_no: e.target.value,
                            })
                          }
                        />
                        <label className={addData.mobile_no ? "filled" : ""}>
                          Mobile No
                        </label>
                      </div>

                      <div className="floating-label">
                        <input
                          className="form-control"
                          type="email"
                          placeholder=""
                          value={UpdatedData.email}
                          onChange={(e) =>
                            setUpdatedData({
                              ...UpdatedData,
                              email: e.target.value,
                            })
                          }
                          required
                        />
                        <label className={addData.email ? "filled" : ""}>
                          Email
                        </label>
                      </div>

                      <div className="floating-label">
                        <input
                          className="form-control"
                          type="text"
                          placeholder=""
                          value={UpdatedData.qualification}
                          onChange={(e) =>
                            setUpdatedData({
                              ...UpdatedData,
                              qualification: e.target.value,
                            })
                          }
                          required
                        />
                        <label
                          className={addData.qualification ? "filled" : ""}
                        >
                          Qualification
                        </label>
                      </div>

                      <div className="col-lg-12 mt-3">
                        <div
                          className={`${UpdatedData.Source_type == "Reference"
                            ? "floating-label"
                            : "d-none"
                            }`}
                        >
                          <select
                            className="form-control"
                            value={UpdatedData.referal_candidate}
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                referal_candidate: e.target.value,
                              })
                            }
                          >
                            <option value="">Select Reference Type</option>
                            <option value="student">Student</option>
                            <option value="staff">Staff</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6 mt-1">
                      <div className="col-lg-12">
                        <div className="floating-label">
                          <label className="form-label">
                            {/* <b>Category</b> */}
                          </label>
                          <select
                            className="form-select"
                            value={UpdatedData.category}
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                category: e.target.value,
                              })
                            }
                            required
                          >
                            <option>Select Category</option>
                            {category.map((item, index) => (
                              <option key={index} value={item.category_name}>
                                {item.category_name}
                              </option>
                            ))}
                          </select>
                          <label
                            className={UpdatedData.category ? "filled" : ""}
                          ></label>
                        </div>
                      </div>

                      <div className="floating-label">
                        <label className="form-label">
                          {/* <b>Course</b> */}
                        </label>
                        <select
                          className="form-select"
                          value={UpdatedData.Prefered_course}
                          onChange={handleCourseChange}
                          required
                        >
                          <option>Select Course</option>
                          {responseDatas.map((item, index) => (
                            <option key={index} value={item.course_name}>
                              {item.course_id} - {item.course_name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* //////////////////recent commmet part  ///////////////////////////////////////////////////////////////// */}

                      <div className="floating-label mt-4">
                        <input
                          className="form-control"
                          type="date"
                          placeholder=""
                          value={
                            UpdatedData.Enquiry_date
                              ? formatDatefitching(UpdatedData.Enquiry_date)
                              : ""
                          }
                          onChange={(e) =>
                            setUpdatedData({
                              ...UpdatedData,
                              Enquiry_date: e.target.value,
                            })
                          }
                          required
                        />
                        <label
                          className={UpdatedData.Enquiry_date ? "filled" : ""}
                        >
                          Enquiry Date
                        </label>
                      </div>

                      <div className="floating-label">
                        <input
                          className="form-control"
                          type="text"
                          placeholder=""
                          value={UpdatedData.other_location}
                          onChange={(e) =>
                            setUpdatedData({
                              ...UpdatedData,
                              other_location: e.target.value,
                            })
                          }
                          required
                        />
                        <label
                          className={UpdatedData.other_location ? "filled" : ""}
                        >
                          Other location
                        </label>
                      </div>

                      <div className="floating-label">
                        {/* Select Dropdown */}
                        <select
                          className="form-control mt-4"
                          value={UpdatedData.purpose_enquiry}
                          onChange={handleSelectChange} // Update state when a new option is selected
                          required
                        >
                          <option value="">Select Purpose Enquiry</option>{" "}
                          {/* Placeholder option */}
                          {purpose.length > 0 ? (
                            purpose.map((item, index) => (
                              <option key={index} value={item.enquiry_purpose}>
                                {item.enquiry_purpose}
                              </option>
                            ))
                          ) : (
                            <option disabled>Loading options...</option> // Display a loading message if no data is available
                          )}
                        </select>

                        {/* Label that gets the "filled" class when the value is selected */}
                        <label
                          className={
                            UpdatedData.purpose_enquiry ? "filled" : ""
                          }
                        >
                          Purpose Enquiry
                        </label>
                      </div>

                      <div className="floating-label mt-4">
                        <select
                          className="form-control"
                          value={UpdatedData.Source_type}
                          onChange={handleSelectChangesource} // Update state when a new option is selected
                          required
                        >
                          <option>Select Source</option>
                          {source.map((item, index) => (
                            <option key={index} value={item.source_type}>
                              {item.source_type}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-lg-12 mt-3">
                        <div
                          className={`${UpdatedData.referal_candidate === "student" &&
                            UpdatedData.Source_type === "Reference"
                            ? "floating-label"
                            : "d-none"
                            }`}
                        >
                          <select
                            className="form-control"
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                referal_candidate_name: e.target.value,
                              })
                            }
                            value={UpdatedData.referal_candidate_name || ""} // Ensure value is linked to state and handle
                          >
                            <option value="">Select student</option>
                            {studentId.map((data, index) => (
                              <option key={index} value={data._id}>
                                {data.student_name_lead} - {data.roll_no}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div
                          className={`${UpdatedData.referal_candidate === "staff" &&
                            UpdatedData.Source_type === "Reference"
                            ? "floating-label"
                            : "d-none"
                            }`}
                        >
                          <select
                            className="form-control"
                            onChange={(e) =>
                              setUpdatedData({
                                ...UpdatedData,
                                referal_candidate_name: e.target.value,
                              })
                            }
                            value={UpdatedData.referal_candidate_name || ""}
                          >
                            <option value="">Select Staff</option>
                            {stafftId.map((data, index) => (
                              <option key={index} value={data._id}>
                                {data.name} - {data.empid}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            className="cancelbut"
            variant="secondary"
            onClick={() => setUpdateShow(false)}
          >
            Cancel
          </Button>
          <Button
            className="submitbut"
            variant="primary"
            onClick={() => handleupdatesubmit(UpdatedData._id)}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>

      {/* /////////////////////////////////////////////////////////////////////////////////////////////////////////// */}

      {/* ----------------update */}

      <Modal
        className="addmodals"
        show={isUpdateshowModal}
        onHide={() => setUpdateShowModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title id="modeti"> Update Scheduless</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Other input fields */}
          <div className="row">
            <div className="col-lg-12 ">
              <div className=" p-2 pb-0">
                <div className="form-group">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="floating-label mt-1">
                        <label className="form-label">
                          <b></b>
                        </label>
                        <select
                          className="form-select"
                          placeholder=""
                          value={UpdatedData.branch_id}
                          onChange={(e) =>
                            setUpdatedData({
                              ...UpdatedData,
                              branch_id: e.target.value,
                            })
                          }
                          required
                          disabled
                        >
                          <option value="">Select Branch </option>
                          {branch.map((item, index) => (
                            <option key={index} value={item._id}>
                              {item.branch_name}
                            </option>
                          ))}
                        </select>
                        <label
                          className={addData.branch_id ? "filled" : ""}
                        ></label>
                      </div>{" "}
                    </div>
                    <div className="col-lg-6">
                      <div className="floating-label">
                        <input
                          className="form-control"
                          type="text"
                          placeholder=""
                          disabled
                          value={UpdatedData.student_name}
                          onChange={(e) =>
                            setUpdatedData({
                              ...UpdatedData,
                              student_name: e.target.value,
                            })
                          }
                          required
                        />
                        <label className={addData.student_name ? "filled" : ""}>
                          Name
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="floating-label">
                        <input
                          className="form-control"
                          type="tel"
                          disabled
                          placeholder=""
                          value={UpdatedData.mobile_no}
                          onChange={(e) =>
                            setUpdatedData({
                              ...UpdatedData,
                              mobile_no: e.target.value,
                            })
                          }
                          required
                        />
                        <label className={addData.mobile_no ? "filled" : ""}>
                          Mobile No
                        </label>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="floating-label">
                        <input
                          className="form-control"
                          type="email"
                          disabled
                          placeholder=""
                          value={UpdatedData.email}
                          onChange={(e) =>
                            setUpdatedData({
                              ...UpdatedData,
                              email: e.target.value,
                            })
                          }
                          required
                        />
                        <label className={addData.email ? "filled" : ""}>
                          Email
                        </label>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="floating-label">
                        <label className="form-label">
                          {/* <b>Category</b> */}
                        </label>
                        <select
                          className="form-select"
                          value={UpdatedData.category}
                          onChange={(e) =>
                            setUpdatedData({
                              ...UpdatedData,
                              category: e.target.value,
                            })
                          }
                          required
                          disabled
                        >
                          <option>Select Category</option>
                          {category.map((item, index) => (
                            <option key={index} value={item.category_name}>
                              {item.category_name}
                            </option>
                          ))}
                        </select>
                        <label
                          className={UpdatedData.category ? "filled" : ""}
                        ></label>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="floating-label">
                        <label className="form-label"></label>
                        <select
                          className="form-select"
                          value={updateData.Prefered_course}
                          onChange={handleCourseChange}
                          required
                          disabled
                        >
                          <option>Select Course</option>
                          {responseDatas.map((item, index) => (
                            <option key={index} value={item.course_name}>
                              {item.course_id} - {item.course_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="floating-label">
                        <input
                          className="form-control"
                          type="date"
                          disabled
                          placeholder=""
                          value={
                            UpdatedData.Enquiry_date
                              ? formatDatefitching(UpdatedData.Enquiry_date)
                              : ""
                          }
                          onChange={(e) =>
                            setUpdatedData({
                              ...UpdatedData,
                              Enquiry_date: e.target.value,
                            })
                          }
                          required
                        />
                        <label
                          className={UpdatedData.Enquiry_date ? "filled" : ""}
                        >
                          Enquiry Date
                        </label>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="floating-label">
                        <input
                          className="form-control"
                          type="text"
                          placeholder=""
                          value={UpdatedData.other_location}
                          onChange={(e) =>
                            setUpdatedData({
                              ...UpdatedData,
                              other_location: e.target.value,
                            })
                          }
                          required
                        />
                        <label
                          className={UpdatedData.other_location ? "filled" : ""}
                        >
                          Other location
                        </label>
                      </div>
                    </div>

                    <select
                      className="form-control"
                      disabled
                      onChange={(e) =>
                        setUpdatedData({
                          ...UpdatedData,
                          Source_type: e.target.value,
                        })
                      }
                      value={UpdatedData.Source_type || ""} // Ensure it's linked to state
                    >
                      {source.map((item, index) => (
                        <option key={index} value={item.source_type}>
                          {item.source_type}
                        </option>
                      ))}
                    </select>

                    <div className="col-lg-6 mt-3">
                      <div
                        className={`${UpdatedData.Source_type == "Reference"
                          ? "floating-label"
                          : "d-none"
                          }`}
                      >
                        <select
                          disabled
                          className="form-control"
                          value={UpdatedData.referal_candidate}
                          onChange={(e) =>
                            setUpdatedData({
                              ...UpdatedData,
                              referal_candidate: e.target.value,
                            })
                          }
                        >
                          <option value="">Select Reference Type</option>
                          <option value="student">Student</option>
                          <option value="staff">Staff</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-6 mt-3">
                      {/* Student Referral Dropdown */}
                      <div
                        className={`${UpdatedData.referal_candidate === "student" &&
                          UpdatedData.Source_type === "Reference"
                          ? "floating-label"
                          : "d-none"
                          }`}
                      >
                        <select
                          className="form-control"
                          disabled
                          onChange={(e) =>
                            setUpdatedData({
                              ...UpdatedData,
                              referal_candidate_name: e.target.value,
                            })
                          }
                          value={UpdatedData.referal_candidate_name || ""} // Ensure value is linked to state and handle empty value
                        >
                          <option value="">Select student</option>
                          {studentId.map((data, index) => (
                            <option key={index} value={data._id}>
                              {data.student_name_lead} - {data.roll_no}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Staff Referral Dropdown */}

                      {/* {console.log("hi sibi ", localStorage.getItem("role_id"))} */}
                      <div
                        className={`${UpdatedData.referal_candidate === "staff" &&
                          UpdatedData.Source_type === "Reference"
                          ? "floating-label"
                          : "d-none"
                          }`}
                      >
                        <select
                          disabled
                          className="form-control"
                          onChange={(e) =>
                            setUpdatedData({
                              ...UpdatedData,
                              referal_candidate_name: e.target.value,
                            })
                          }
                          value={
                            UpdatedData.referal_candidate_name ||
                            sessionStorage.getItem("role_id")
                          } // Ensure value is linked to state and handle empty value
                        >
                          <option value="">Select staff</option>
                          {stafftId.map((data, index) => (
                            <option key={index} value={data._id}>
                              {data.name} - {data.empid}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`${UpdatedData.followups_status == "Converted"
                ? "d-none"
                : "col-lg-12"
                }`}
            >
              <div className="row">
                {localStorage.getItem("branch_id") === null ||
                  localStorage.getItem("branch_id") === "null" ? (
                  // Render text input when branch_id is null or "null"

                  // Render dropdown when branch_id is not null or "null"
                  <div className="col-lg-6 mt-3">
                    <div className="floating-label">
                      <select
                        className="form-control"
                        //  value={idlocal || ""}
                        value={UpdatedData.assign_staff}
                        onChange={handleSelectChangedd}
                        required
                      >
                        {/* Add your <option> elements here */}
                        <option value="">Select Staff</option>
                        {stafftId.map((item, index) => (
                          <option key={index} value={item._id}>
                            {item.empid} - {item.name}
                          </option>
                        ))}
                      </select>
                      {/* <label className={idlocal ? "filled" : ""}>Assign Staff</label> */}
                      <label
                        className={UpdatedData.assign_staff ? "filled" : ""}
                      ></label>
                      {console.log(
                        "the assign staff",
                        UpdatedData.assign_staff
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="col-lg-6 mt-3">
                    <div className="floating-label">
                      <input
                        type="text"
                        className="form-control"
                        value={idlocal || ""}
                        disabled={true} // Use an empty string if idlocal is null or undefined
                        // Makes the input field disabled
                        placeholder="" // Keep placeholder empty for floating label to work correctly
                        required
                      />
                      <label className={idlocal ? "filled" : ""}>
                        Assign Staff
                      </label>
                    </div>
                  </div>
                )}

                <div className="col-lg-6 mt-3">
                  <div className="floating-label">
                    <select
                      className="form-control"
                      onChange={(e) =>
                        setUpdatedData({
                          ...UpdatedData,
                          contact_type: e.target.value,
                        })
                      }
                      value={UpdatedData.contact_type || ""} // Ensure value is linked to state and handle empty value
                    >
                      <option value="">Contact Type</option>
                      <option value="phone">Phone Call</option>
                      <option value="email">Email</option>
                      <option value="whatsapp">Whatsapp</option>
                    </select>
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="date"
                      placeholder=""
                      value={
                        UpdatedData.followups_date
                          ? formatDatefitching(UpdatedData.followups_date)
                          : ""
                      }
                      onChange={(e) =>
                        setUpdatedData({
                          ...UpdatedData,
                          followups_date: e.target.value,
                        })
                      }
                      required
                    />
                    <label
                      className={
                        formatDatefitching(UpdatedData.followups_date)
                          ? "filled"
                          : ""
                      }
                    >
                      Date
                    </label>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="time"
                      placeholder=""
                      value={UpdatedData.followups_time}
                      onChange={(e) =>
                        setUpdatedData({
                          ...UpdatedData,
                          followups_time: e.target.value,
                        })
                      }
                      required
                    />
                    <label
                      className={UpdatedData.followups_time ? "filled" : ""}
                    >
                      Time
                    </label>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-6">
                    <div>
                      <input
                        type="radio"
                        id="html"
                        classNameame="mx-2"
                        value="Interest"
                        onChange={(e) => interstedHandel(e)}
                      />
                      <label for="html">Interest</label>
                      <br></br>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="floating-label">
                      <select
                        className="form-control"
                        value={UpdatedData.followups_status || ""}
                        onChange={(e) =>
                          setUpdatedData({
                            ...UpdatedData,
                            followups_status: e.target.value,
                          })
                        }
                        required
                      >
                        <option value="">Select Followups Status</option>
                        {/* Default option */}
                        <option value="Rescheduled">Rescheduled</option>
                        <option value="Walkin">Walkin</option>
                        <option value="Unqualified">Unqualified</option>
                        <option value="NotReachable">Not Reachable</option>
                        <option value="Phone Ringing">Phone Ringing</option>
                      </select>
                      <label
                        className={UpdatedData.followups_status ? "filled" : ""}
                      >
                        Followups Status
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button
            className="cancelbut"
            variant="secondary"
            onClick={() => setUpdateShowModal(false)}
          >
            Cancel
          </Button>
          <Button
            className="submitbut"
            variant="primary"
            onClick={() => handleupdatesubmitdetails(UpdatedData._id)}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ----------------delete */}

      <Modal
        className="modal"
        show={deleteShowModals}
        onHide={handleCloseModal}
      >
        <Modal.Header>
          <p id="modeti">Are you sure you want to Delete?</p>
        </Modal.Header>
        <Modal.Body>
          <label className="form-label d-flex">
            <h5 className="mx-1"> Student :</h5> <h5>{getdeletename} </h5>
          </label>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="cancelbut"
            variant="secondary"
            onClick={handleCloseModal}
          >
            Close
          </Button>
          <Button
            className="submitbut"
            variant="primary"
            onClick={handleDelete}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* _------------------------------pagination button -------------------------------- */}
      <div className="mt-3 pb-5">
        <div className="row">
          <div className="col-lg-7 col-sm-12 mt-1">
            <span className="text-dark">
              Page {state.pageIndex + 1} of {pageCount}
            </span>
          </div>
          <div className="col-lg-5">
            <div className="mt-3 pb-5">
              <nav>
                <ul className="pagination justify-content-center">
                  {createPagination()} {/* Pagination buttons */}
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Enquiry;
